module.exports = __webpack_public_path__ + "img/pethouse32.a735053e.jpg";